var map = {
	"./all.jpg": 799,
	"./bird.jpg": 440,
	"./cat.jpg": 271,
	"./dog.jpg": 573,
	"./fish.jpg": 170,
	"./reptiles.jpg": 145,
	"./rodents.jpg": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 628;